<template>
  <div>
    <SelectorPanel
      type="travelTracker"
      text="Travel Tracker"
      :disabled="disabled"
      :force-close="forceClose"
      @click="handlePanelOpen"
      content-class="px-0"
    >
      <v-container
        class="pa-0 hyp-search-container"
        :class="{
          'hyp-search-container-min': isMinimized,
          'hyp-search-container-full': !isMinimized,
        }"
      >
        <div class="pull-left hyp-search-filter-container px-2">
          <SelectorPanelHeader
            type="travelTracker"
            title="Travel Tracker"
            class="pb-2"
            @click-close="handleClickClose"
          >
          </SelectorPanelHeader>

          <TravelTrackerContentFilters
            @change-travel-tracker-enabled="handleChangeTravelTrackerEnabled"
            @change-trip-statuses="handleChangeTripStatus"
            @change-is-vip="handleChangeIsVip"
            @change-traveler-type="handleChangeTravelerType"
            @change-travel-type="handleChangeTravelType"
            @change-location="handleChangeLocation"
            @change-security-risk="handleChangeSecurityRisk"
            @change-date="handleChangeDate"
            @change-time="handleChangeTime"
            @change-has-filters-set="handleChangeHasFiltersSet"
            @reset="handleReset"
          ></TravelTrackerContentFilters>
        </div>
        <div class="pull-left hyp-search-content-container">
          <TravelTrackerContent
            :is-minimized="isMinimized"
            :travel-tracker-enabled="travelTrackerEnabled"
            :trip-statuses="tripStatuses"
            :is-vip="isVip"
            :traveler-types="travelerTypes"
            :travel-types="travelTypes"
            :location="locations"
            :security-risks="securityRisks"
            :date="date"
            :time="time"
            :should-pull-data="shouldPullData"
            @click-minimize="handleClickMinimize"
          ></TravelTrackerContent>
        </div>
        <div class="clearfix"></div>
      </v-container>
    </SelectorPanel>
  </div>
</template>

<script>
import lodashDebounce from "lodash/debounce";

export default {
  name: "TravelTrackerSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader"),
    TravelTrackerContentFilters: () =>
      import("@/components/isosTravelTracker/TravelTrackerContentFilters"),
    TravelTrackerContent: () =>
      import("@/components/isosTravelTracker/TravelTrackerContent"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isOpen: false,
    forceClose: null,
    isMinimized: false,
    refresh: new Date().toISOString(),
    travelTrackerEnabled: false,
    tripStatuses: null,
    isVip: null,
    travelerTypes: null,
    travelTypes: null,
    locations: false,
    securityRisks: null,
    time: null,
    date: null,
  }),
  computed: {
    crLogoSrc() {
      return require("@/assets/images/control-risks-logo-dark.png");
    },
    shouldPullData() {
      if (!this.politicalEnabled && !this.maritimeEnabled) {
        return false;
      }
      return true;
    },
  },
  methods: {
    handlePanelOpen(open) {
      lodashDebounce(() => {
        this.isOpen = open;
      }, 1000)();
    },
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
    handleClickMinimize() {
      this.isMinimized = !this.isMinimized;
    },
    handleChangeTravelTrackerEnabled(params) {
      this.travelTrackerEnabled = params;
    },
    handleChangeTripStatus(params) {
      this.tripStatuses = params;
    },
    handleChangeIsVip(params) {
      this.isVip = params;
    },
    handleChangeTravelerType(params) {
      this.travelerTypes = params;
    },
    handleChangeTravelType(params) {
      this.travelTypes = params;
    },
    handleChangeLocation(params) {
      this.locations = params;
    },
    handleChangeSecurityRisk(params) {
      this.securityRisks = params;
    },
    handleChangeDate(params) {
      this.date = params;
    },
    handleChangeTime(params) {
      this.time = params;
    },
    handleChangeHasFiltersSet(params) {
      this.filtersSet = params;
    },
    handleReset(params) {
      this.reset = params;
    },
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        this.refresh = new Date().toISOString();
      }
    },
  },
  beforeDestroy() {
    this.isOpen = false;
  },
};
</script>

<style scoped>
.hyp-search-container {
  padding: 0 !important;
  display: grid;
  grid-template-columns: 323px auto;
}
.hyp-search-container-min {
  width: 365px;
}
.hyp-search-container-full {
  width: 723px;
}
.hyp-search-filter-container {
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
}
.hyp-search-content-container {
  box-sizing: border-box;
  height: 100vh;
}
.reset-filter-holder {
  text-align: center;
  font-size: 14px;
  width: 100%;
}
</style>
